import { getCommercialStockProducts, getResearchStockProducts, } from "../api/generated/wrappers/product";
import { getCommercialEigenStockProducts, getResearchEigenStockProducts, } from "../api/generated/wrappers/product";
import { getCommercialBOMList, getResearchBOMList, } from "../api/generated/wrappers/product";
import { getStockBySpot } from "../api/generated/wrappers/product";
import { createQueryKeys } from "./create-query-keys";
const stockQueryKeys = createQueryKeys("stock", {
    all: (isCommercial, params) => ({
        queryKey: ["all", isCommercial, params],
        queryFn: async () => isCommercial
            ? await getCommercialStockProducts(params)
            : await getResearchStockProducts(params),
    }),
    bySpot: (spotId) => ({
        queryKey: ["bySpot", spotId],
        queryFn: async () => await getStockBySpot(spotId),
    }),
    eigen: (isCommercial, params) => ({
        queryKey: ["eigen", isCommercial, params],
        queryFn: async () => isCommercial
            ? await getCommercialEigenStockProducts(params)
            : await getResearchEigenStockProducts(params),
    }),
    bom: (isCommercial, productId) => ({
        queryKey: ["bom", isCommercial, productId],
        queryFn: async () => isCommercial
            ? await getCommercialBOMList(productId)
            : await getResearchBOMList(productId),
    }),
});
export default stockQueryKeys;
